import { ElxCopy } from "@elixir/components";
import { getExperimentsPath, getExpStudioPath } from "../shared.utils";
import PreserveParamsLink from "./PreserveParamsLink";
import useAppInsights from "../../Hooks/UseAppInsights";
import { NavType } from "../AppInsights";

interface ExperimentLinkProps {
  /**
   * The name of the extension the experiment belongs to.
   */
  extension: string;
  /**
   * The name of the experiment
   */
  experiment: string;
  /**
   * Children elements to be rendered inside the link.
   */
  children?: React.ReactNode;
  [key: string]: any;
}

/**
 * A link component for navigating to a specific experiment and preserving URL parameters.
 */
const ExperimentLink: React.FC<ExperimentLinkProps> = ({
  extension,
  experiment,
  children,
  ...props
}) => {
  const { trackNavigationEvent, trackOperationEvent } =
    useAppInsights("ExperimentLink");
  const experimentUrl = getExperimentsPath(extension, experiment);
  const expStudioUrl = getExpStudioPath(extension, experiment);

  return (
    <ElxCopy
      textToCopy={expStudioUrl}
      mouseOverTooltipText="Copy link"
      textCopiedTooltipText="Copied link!"
      onClick={() => {
        trackOperationEvent({
          operation: "CopyLink",
          function: "ElxCopy.onClick",
          properties: { experimentUrl: expStudioUrl },
        });
      }}
    >
      <PreserveParamsLink
        to={experimentUrl}
        {...props}
        onClick={() =>
          trackNavigationEvent({
            destination: experimentUrl,
            function: "PreserveParamsLink.onClick",
            navType: NavType.Internal,
          })
        }
      >
        {children}
      </PreserveParamsLink>
    </ElxCopy>
  );
};

export default ExperimentLink;
